import { FaXTwitter } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const twitterBaseSettings: SocialPlatformBaseSettings = {
  name: "X (Twitter)",
  icon: FaXTwitter,
  fields: {
    caption: "required",
    location: "optional",
    altText: "optional",
    linkAttachment: "optional", // Twitter Cards
    polls: "optional",
    userTags: "optional",
  },
  limits: {
    caption: 280, // 25k for Premium
    images: 4,
    videos: 1,
    videoDurationSeconds: 140,
    pollOptions: 4,
  },
  notes: ["Ideal caption length: 70-100 characters."],
  postTypes: {
    post: {}, // Default type
  },
};
